module.exports = __webpack_public_path__ + "static/media/AjusteEstoque6.84a7e894.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancAjusteEstoque/AjusteEstoque6.png
// module id = 2053
// module chunks = 0